import { atomWithReset } from "jotai/utils";

export const isPromoAvailableAtom = atomWithReset<boolean>(false);
